import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    formControlAutoComplete: {
      margin: "10px",
    },
    formControl: {
      minWidth: "60%",
      margin: "10px",
    },
    input: {
      padding: "5px",
    },
    centerTypographyRoot: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "top",
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    paddingPaper: {
      paddingBottom: theme.spacing(2),
      minHeight: "100%",
      height: "100%",
    },
    print: { pageBreakAfter: 'always' },
    noPrint: {},
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
      marginTop: "10px",
    },
    datePicker: {
      minWidth: "100%",
      marginTop: theme.spacing(2),
    },

    buttonZeitraum: {
      "&.Mui-selected": {
        backgroundColor: theme.palette.secondary.main + "!important",
        color: "black" + "!important",
        borderColor: theme.palette.secondary.main + "!important",
      },
    },

    disabledColor: {
      "&.Mui-disabled": {
        backgroundColor: theme.palette.grey[200] + "!important",
        color: "black" + "!important",
        borderColor: theme.palette.grey[400] + "!important",
      },
    },

    disabledTab: {
      "&.Mui-disabled": {
        color: theme.palette.grey[300] + "!important",
      },
    },

    textFieldBorder: {
      borderColor: theme.palette.grey[200] + "!important",
      "& .MuiOutlinedInput-root": {
        borderColor: theme.palette.grey[200] + "!important",
        "&:active": {
          borderColor: theme.palette.grey[200] + "!important",
        },
        "&:hover": {
          borderColor: theme.palette.grey[200] + "!important",
        },
      },
      "& .MuiTextField-root": {
        borderColor: theme.palette.grey[200] + "!important",
        "&:active": {
          borderColor: theme.palette.grey[200] + "!important",
        },
        "&:hover": {
          borderColor: theme.palette.grey[200] + "!important",
        },
      },
    },

    marks: {
      fontSize: "small",
      markLabel: {
        fontSize: "20px",
      },
      "& .MuiSlider-markLabel": {
        fontSize: "0.9rem",
      },
    },

    gridStyle: {
      border: 1,
      "& .MuiDataGrid-columnsContainer": {
        backgroundColor: theme.palette.grey[50],
      },
      "& .super-app-theme--cell": {
        backgroundColor: theme.palette.grey[50],
      },
      "& .MuiDataGrid-iconSeparator": {
        display: "none",
      },
      "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
        borderRight: `1px solid ${"#f0f0f0"}`,
      },
      "& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
        borderBottom: `1px solid ${"#f0f0f0"}`,
      },
      "& .pos": {
        backgroundColor: "#99cc99",
        color: "#1a3e72",
      },
      "& .neg": {
        backgroundColor: "#ffd27f",
        color: "#1a3e72",
      },
      "& .neu": {
        backgroundColor: "#e39999",
        color: "#1a3e72",
      },
    },

    table: {
      borderCollapse: "separate",
    },

    tableCellStyleGreyFrame: {
      border: `1px solid ${"#ffffff"}`,
      borderBottom: `1px solid ${"#ffffff"}`,
      color: theme.palette.grey[600],
      backgroundColor: theme.palette.grey[200],
    },
    tableCellKursivStyle: {
      borderTop: `1px solid ${"#ffffff"}`,
      borderBottom: `1px solid ${"#ffffff"}`,
      fontStyle: "italic",
      color: theme.palette.grey[600],
      backgroundColor: theme.palette.grey[200],
    },

    tableHeaderHorizontalLeftmost: {
      border: `1px solid ${theme.palette.grey[200]}`,
      paddingBottom: `-1px`,
      backgroundColor: "#ffffff",
      position: "sticky",
      top: 0,
      left: 0,
      zIndex: 999,
    },
    tableHeaderHorizontalLeftmostDetailed: {
      border: `1px solid ${theme.palette.grey[200]}`,
      backgroundColor: "#ffffff",
      position: "sticky",
      textAlign: "center",
      top: 0,
      left: 0,
      zIndex: 999,
    },
    tableHeaderHorizontal: {
      border: `1px solid ${theme.palette.grey[200]}`,
      backgroundColor: "#ffffff",
      position: "sticky",
      top: 0,
      zIndex: 99,
    },
    tableHeaderHorizontalFocused: {
      border: `1px solid ${theme.palette.grey[200]}`,
      backgroundColor: `${theme.palette.grey[200]}`,
      position: "sticky",
      top: 0,
      zIndex: 99,
    },
    tableCellClickable: {
      border: `1px solid ${theme.palette.grey[200]}` + "!important",
      backgroundColor: `${theme.palette.grey[100]}`,
      textAlign: "center",
      "& .MuiTableCell-root": {
        "&:hover": {
          backgroundColor: theme.palette.grey[300] + "!important",
        },
      },
      "&:hover": {
        backgroundColor: theme.palette.grey[300] + "!important",
      },
    },

    tableCellRegular: {
      border: `1px solid ${theme.palette.grey[200]}` + "!important",
      backgroundColor: `${theme.palette.grey[100]}`,
      textAlign: "center",
    },

    tableHeaderVertical: {
      borderRight: `1px solid ${theme.palette.grey[200]}`,
      backgroundColor: "#ffffff",
      position: "sticky",
      left: 0,
      zIndex: 99,
    },
    tableHeaderVerticalFocused: {
      borderRight: `1px solid ${theme.palette.grey[200]}`,
      backgroundColor: `${theme.palette.grey[200]}`,
      position: "sticky",
      left: 0,
      zIndex: 99,
    },

    tableCellStyle: {
      border: `1px solid ${theme.palette.grey[200]}` + "!important",
      backgroundColor: ` ${theme.palette.grey[100]}`,
      textAlign: "center",
    },

    tableCellHeaderStyleVertical: {
      border: `1px solid ${theme.palette.grey[200]}` + "!important",
      writingMode: "vertical-lr",
      transform: `translate(0%, 0%) rotate(180deg)`,
    },

    tableCellHeaderStyleNonVertical: {
      border: `1px solid ${theme.palette.grey[200]}` + "!important",
    },

    tableCellBlank: {
      borderBottom: `1px solid ${"#ffffff"}`,
      borderRight: `1px solid ${theme.palette.grey[200]}`,
    },
    tableCellUw: {
      borderRight: `1px solid ${theme.palette.grey[200]}`,
      "& .MuiTableCell-root": {
        "&:hover": {
          backgroundColor: theme.palette.grey[200] + "!important",
        },
      },
      "&:hover": {
        backgroundColor: theme.palette.grey[200] + "!important",
      },
    },
    RadioButtonLabel: {
      "& .MuiFormControlLabel-label": {
        fontSize: "0.9rem",
      },
    },

    tableHeaderHorizontalBlank: {
      borderBottom: `1px solid ${"#ffffff"}`,
      borderRight: `1px solid ${theme.palette.grey[200]}`,
      position: "sticky",
      top: 0,
      zIndex: 99,
    },
  }),
  { index: 1 }
);
